import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import EntityEvent from '@app/models/entity-event';
import PagedResults from '@app/models/paged-results';

/**
 * Admin/developer diagnostic service to obtain raw entity data for review and troubleshooting services.
 */
@Injectable({
  providedIn: "root",
})
export class EntityService {
  private readonly _componentName = 'EntityService';

  constructor(private http: HttpClient) {}

  /**
   * Gets a set of entity data for an entity type
   */
  public getEntitySet(entityType: string, primaryKeyValue: any) {
    return this.http.get<any>(`entity/${entityType}/${primaryKeyValue}`);
  }

  /**
   * Gets all entities for a given entity type
   * EntityController needs to have cases for specific types.
   * @param entityType
   * @returns
   */
  public getAll(entityType: string) {
    return this.http.get<any>(`entity/${entityType}`);
  }

  /**
   * Adds a new entity event.  returns the entity id (of the row in the EntityEvent table)
   * HTTP Post to api/entity/event
   * @param e
   * @returns
   */
  public addEntityEvent(e: EntityEvent) {
    if (!e) {
      throw new Error("'EntityEvent' parameter is null/empty.");
    }

    return this.http.post<number>('entity/event', e);
  }

  /**
   * Searches for entity events
   * @returns
   */
  public search() {
    return this.http.post<PagedResults>('entity/event/search', null);
  }
}
